import {combineReducers} from "redux";
import single from "features/pages/single-directory/reducer";

export default combineReducers({
    single
})